export default __webpack_public_path__ + "static/media/PIN-CARD-NTO.296e3e7a.png";